import React, {
  lazy,
  Suspense,
  useCallback,
  useContext,
  useEffect,
} from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { getAlbum, DeleteAlbum } from "./galleryService";
import { TostMsg } from "../../../App";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
const ComponentLoader = React.memo(
  lazy(() => import("../../../Shared/Sidebar/ComponentLoader"))
);
const imageURL = process.env.REACT_APP_GALLARY_iMAGE;
function GalleryBody() {
  const [albumTypeData, setAlbumTypeData] = useState([]);
  const [createdAlbumFristDataSet, setCreatedAlbumFristDataSet] = useState([]);
  const [createdAlbumSecondDataSet, setCreatedAlbumSecondDataSet] = useState(
    []
  );
  const [createdAlbumLastDataSet, setCreatedAlbumLastDataSet] = useState([]);
  const [galleryAlbumDeleteId, setGalleryAlbumDeleteId] = useState(null);
  const [galleryHeader, setGalleryHeader] = useState("");
  const [loading, setLoading] = useState(false);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const toster = useContext(TostMsg);
  const [galleryCreate, setGalleryCreate] = useState(false);
  const [showGallaryDataNotFound, setShowGallaryDataNotFound] = useState(false);
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  let history = useHistory();
  const GalleryDefaultImage = "/images/placeholder_profile.png";
  const GalleryDefaultImagefeed = "/images/no-data-found/feed_dummy.png";
  const GalleryDefaultVideoImage = "/images/no-data-found/video_image.png";
  const [noData, setNoData] = useState([]);
  const [noDataGallery, setNoDataGallery] = useState([]);
  useEffect(() => {
    permissionAccouncementList();
    getAlbumType();
    getAlbumData();
    GetMasterSystemAlertList("Gallery_header", 1);
    GetMasterSystemAlertList("No_data_found_gla", 3);
    GetMasterSystemAlertList("Picture_Unavailable", 2);
  }, []);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Album.Create") {
        setGalleryCreate(true);
      }
    });
  };

  async function getAlbumType() {
    setLoading(true);
    const param = {
      masterType: "albumtype",
      organisationId: userDetails?.OrgId,
    };
    try {
      const response = await GetMasterTypeData(param);
      let newAlbumList = response?.Data?.toSpliced(0, 0, {
        GUID: "0",
        Name: "All Album",
      });
      setAlbumTypeData(newAlbumList);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  // GET  Created  Album     .
  async function getAlbumData(type) {
    let AlbumTypeId = 0;
    if (type?.Id == 101) {
      AlbumTypeId = type?.Id;
    } else if (type?.Id == 102) {
      AlbumTypeId = type?.Id;
    } else {
      AlbumTypeId = 0;
    }
    const param = {
      GUID: String(""),
      AlbumId: 0,
      EmpId: 0,
      AlbumTypeId: AlbumTypeId,
    };
    try {
      const response = await getAlbum(param);
      if (response?.Data?.length === 0) {
        setShowGallaryDataNotFound(true);
      } else {
        setShowGallaryDataNotFound(false);
      }
      const updatedData = response?.Data?.map((item) => {
        let mediaPath = item?.MediaPath;

        if (!mediaPath) {
          mediaPath = GalleryDefaultImagefeed;
        } else if (
          mediaPath.endsWith(".mp4") ||
          mediaPath?.toLowerCase()?.endsWith(".mov")
        ) {
          mediaPath = GalleryDefaultVideoImage;
        }
        return {
          ...item,
          MediaPath: mediaPath,
        };
      });
      const FirstArr = updatedData?.slice(0, 1);
      const SecondArr = updatedData?.slice(1, 5);
      const LastArr = updatedData?.slice(5);
      setCreatedAlbumFristDataSet(FirstArr);
      setCreatedAlbumSecondDataSet(SecondArr);
      setCreatedAlbumLastDataSet(LastArr);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function GetMasterSystemAlertList(message, type) {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setGalleryHeader(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      } else if (msg?.Name == message && type == 3) {
        setNoDataGallery(msg?.Desc);
      }
    });
  }

  const handleCreatedAlbumDelete = (id) => {
    setGalleryAlbumDeleteId(id);
  };

  const handleGalleryDefaultImage = useCallback((event) => {
    event.target.src = GalleryDefaultImage;
  }, []);
  const handleGalleryDefaultVideoImage = useCallback((event) => {
    event.target.src = GalleryDefaultVideoImage;
  }, []);
  async function GalleryAlbumDelete() {
    if (galleryAlbumDeleteId) {
      let body = {
        AlbumId: galleryAlbumDeleteId,
        ModifiedById: userDetails?.EmpId,
      };
      setLoading(true);
      try {
        let experiencesLists = await DeleteAlbum(body);
        if (experiencesLists) {
          getAlbumData();
          setLoading(false);
          document.getElementById("delete-ed").click();
          GetMasterSystemAlertList("Gallery_DeleteImage", 0);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        setLoading(false);
      }
    }
  }

  const RedirectToUpdateAlbum = (GUID) => {
    history.push(`/UpdateAlbum/${GUID}`);
  };

  return (
    <div>
      <div id="main-wrapper" className="show menu-toggle">
        <div className="container-fluid position-relation">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="form-head d-flex flex-wrap align-items-center gallery-by">
                <div className="me-auto">
                  <h2 className="main-titleh2">Gallery</h2>
                  <p className="text-light">{galleryHeader}</p>
                </div>
                <div className="d-flex me-3">
                  {albumTypeData?.map((item, index) => (
                    <div className="form-check me-2" key={item?.GUID || index}>
                      <input
                        onChange={() => getAlbumData(item)}
                        defaultChecked={index === 0}
                        className="form-check-input"
                        type="radio"
                        name="gridRadios"
                        value={item?.GUID}
                        id={`radio-${index}`}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`radio-${index}`}
                      >
                        {item?.GUID == 0 ? "" : "By"} {item?.Name}
                      </label>
                    </div>
                  ))}
                  {albumTypeData == null && (
                    <div className="">
                      <div className="notfound">
                        <img
                          src="/images/no-data-found/no_gallery.png"
                          alt=""
                        />
                        <p>{noDataGallery}</p>
                      </div>
                    </div>
                  )}
                </div>
                {galleryCreate && (
                  <Link to={`/CreateAlbum`} className="add-btncss mb-2 w-auto">
                    <i aria-hidden="true" className="fa fa-plus me-2"></i>
                    Create New Album
                  </Link>
                )}
              </div>
              {createdAlbumFristDataSet?.length > 0 ? (
                <div className="row g-3 mt-3">
                  <div className="col-xl-6">
                    <div className="col-xl-12 leftside">
                      <div
                        className="media-feed-item has-background-image"
                        style={{
                          backgroundImage: `url(${JSON?.stringify(
                            createdAlbumFristDataSet[0]?.MediaPath
                          )}`,
                          minHeight: "464px",
                        }}
                      >
                        {createdAlbumFristDataSet[0]?.MediaCount != 0 ? (
                          <span className="tag item-duration">
                            {createdAlbumFristDataSet[0]?.MediaCount}
                            <img src={imageURL} />
                          </span>
                        ) : (
                          ""
                        )}
                        {createdAlbumFristDataSet[0]?.MediaCount === 0 && (
                          <a className="play-button">
                            <Link
                              to={`/SingleGallery/${createdAlbumFristDataSet[0]?.GUID}`}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-arrow-right-square-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M0 14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2zm4.5-6.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5a.5.5 0 0 1 0-1" />
                              </svg>
                            </Link>
                          </a>
                        )}
                        {galleryCreate && (
                          <button
                            onClick={() =>
                              handleCreatedAlbumDelete(
                                createdAlbumFristDataSet[0]?.Id
                              )
                            }
                            className="gallerydeletebtn"
                            title="Delete"
                            data-bs-toggle="modal"
                            data-bs-target="#delete-ed"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-trash"
                              viewBox="0 0 16 16"
                            >
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                              <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                            </svg>
                          </button>
                        )}
                        {galleryCreate && (
                          <button
                            onClick={() =>
                              RedirectToUpdateAlbum(
                                createdAlbumFristDataSet[0]?.GUID
                              )
                            }
                            className="galleryeditbtn"
                            title="Edit Album"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-pencil"
                              viewBox="0 0 16 16"
                            >
                              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                            </svg>
                          </button>
                        )}
                        {createdAlbumFristDataSet[0]?.MediaCount != 0 && (
                          <Link
                            to={`/SingleGallery/${createdAlbumFristDataSet[0]?.GUID}`}
                            className="play-button"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-arrow-right-square-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="M0 14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2zm4.5-6.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5a.5.5 0 0 1 0-1" />
                            </svg>
                          </Link>
                        )}
                        <div className="item-overlay"></div>
                        <div className="overlay-layer">
                          <div className="overlay-content">
                            <Link
                              to={`/SingleGallery/${createdAlbumFristDataSet[0]?.GUID}`}
                            >
                              <div className="inner-content">
                                <h3 className="media-title">
                                  {createdAlbumFristDataSet[0]?.Name}
                                </h3>
                                <p
                                  className="desparagraph"
                                  title={
                                    createdAlbumFristDataSet[0]?.Description
                                  }
                                >
                                  {createdAlbumFristDataSet[0]?.Description}
                                </p>
                                <div className="media-meta">
                                  <img
                                    src={
                                      createdAlbumFristDataSet[0]
                                        ?.EmployeeProfileImage ||
                                      GalleryDefaultImage
                                    }
                                    onError={handleGalleryDefaultImage}
                                    alt=""
                                  />
                                  <a className="meta-item is-hoverable">
                                    {createdAlbumFristDataSet[0]?.EmployeeName}
                                  </a>
                                  <span className="separator">|</span>
                                  <span className="meta-item d-flex align-items-center">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="11"
                                      height="11"
                                      fill="currentColor"
                                      className="bi bi-calendar me-1"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                                    </svg>
                                    {moment(
                                      createdAlbumFristDataSet[0]?.ModifiedDate
                                    ).format("MMM DD YYYY")}{" "}
                                  </span>
                                </div>
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-6">
                    <div className="row g-3">
                      {createdAlbumSecondDataSet?.map((album, index) => {
                        return (
                          <div className="col-xl-6">
                            <div
                              className="media-feed-item has-background-image"
                              style={{
                                backgroundImage: `url(${JSON?.stringify(
                                  album?.MediaPath
                                )})`,
                              }}
                              key={index}
                            >
                              {album?.MediaCount != 0 ? (
                                <span className="tag item-duration">
                                  {album?.MediaCount}
                                  <img
                                    src={` https://core.api.orggenie.com/Uploads/MasterImage/MenuIcons/multipleImages.png`}
                                  />
                                </span>
                              ) : (
                                ""
                              )}
                              {album?.MediaCount === 0 && (
                                <a className="play-button">
                                  <Link to={`/SingleGallery/${album?.GUID}`}>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-arrow-right-square-fill"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M0 14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2zm4.5-6.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5a.5.5 0 0 1 0-1" />
                                    </svg>
                                  </Link>
                                </a>
                              )}
                              {galleryCreate && (
                                <button
                                  onClick={() =>
                                    handleCreatedAlbumDelete(album?.Id)
                                  }
                                  className="gallerydeletebtn"
                                  title="Delete"
                                  data-bs-toggle="modal"
                                  data-bs-target="#delete-ed"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-trash"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                  </svg>
                                </button>
                              )}
                              {galleryCreate && (
                                <button
                                  onClick={() =>
                                    RedirectToUpdateAlbum(album?.GUID)
                                  }
                                  className="galleryeditbtn"
                                  title="Edit Album"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-pencil"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                                  </svg>
                                </button>
                              )}
                              {album?.MediaCount != 0 && (
                                <Link
                                  to={`/SingleGallery/${album?.GUID}`}
                                  className="play-button"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-arrow-right-square-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M0 14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2zm4.5-6.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5a.5.5 0 0 1 0-1" />
                                  </svg>
                                </Link>
                              )}
                              <div className="item-overlay"></div>
                              <div className="overlay-layer">
                                <Link to={`/SingleGallery/${album?.GUID}`}>
                                  <div className="overlay-content">
                                    <div className="inner-content">
                                      <h3 className="media-title break-text">
                                        {album?.Name}
                                      </h3>
                                      <p
                                        className="desparagraph break-text"
                                        title={album?.Description}
                                      >
                                        {album?.Description}
                                      </p>
                                      <div className="media-meta">
                                        <img
                                          src={
                                            album?.EmployeeProfileImage ||
                                            GalleryDefaultImage
                                          }
                                          onError={handleGalleryDefaultImage}
                                          data-demo-src={
                                            album?.EmployeeProfileImage
                                          }
                                          alt=""
                                        />
                                        <a className="meta-item is-hoverable">
                                          {album?.EmployeeName}
                                        </a>
                                        <span className="separator">|</span>
                                        <span className="meta-item d-flex align-items-center">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="11"
                                            height="11"
                                            fill="currentColor"
                                            className="bi bi-calendar me-1"
                                            viewBox="0 0 16 16"
                                          >
                                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                                          </svg>
                                          {moment(album?.ModifiedDate).format(
                                            "MMM DD YYYY"
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              ) : (
                <div></div>
              )}
              <div className="row g-3 mt-0">
                {createdAlbumLastDataSet?.map((album, index) => {
                  return (
                    <div className="col-xl-3" key={index}>
                      <div
                        className="media-feed-item has-background-image"
                        style={{
                          backgroundImage: `url(${JSON?.stringify(
                            album?.MediaPath
                          )})`,
                        }}
                      >
                        {album?.MediaCount != 0 ? (
                          <span className="tag item-duration">
                            {album?.MediaCount}
                            <img
                              src={` https://core.api.orggenie.com/Uploads/MasterImage/MenuIcons/multipleImages.png`}
                            />
                          </span>
                        ) : (
                          ""
                        )}
                        {album?.MediaCount === 0 && (
                          <a className="play-button">
                            <Link to={`/SingleGallery/${album?.GUID}`}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-arrow-right-square-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M0 14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2zm4.5-6.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5a.5.5 0 0 1 0-1" />
                              </svg>
                            </Link>
                          </a>
                        )}
                        {galleryCreate && (
                          <button
                            onClick={() => handleCreatedAlbumDelete(album?.Id)}
                            className="gallerydeletebtn"
                            title="Delete"
                            data-bs-toggle="modal"
                            data-bs-target="#delete-ed"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-trash"
                              viewBox="0 0 16 16"
                            >
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                              <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                            </svg>
                          </button>
                        )}
                        {galleryCreate && (
                          <button
                            onClick={() => RedirectToUpdateAlbum(album?.GUID)}
                            className="galleryeditbtn"
                            title="Edit Album"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-pencil"
                              viewBox="0 0 16 16"
                            >
                              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                            </svg>
                          </button>
                        )}
                        {album?.MediaCount != 0 && (
                          <Link
                            to={`/SingleGallery/${album?.GUID}`}
                            className="play-button"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-arrow-right-square-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="M0 14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2zm4.5-6.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5a.5.5 0 0 1 0-1" />
                            </svg>
                          </Link>
                        )}
                        <div className="item-overlay"></div>
                        <Link to={`/SingleGallery/${album?.GUID}`}>
                          <div className="overlay-layer">
                            <div className="overlay-content">
                              <div className="inner-content">
                                <h3 className="media-title break-text">
                                  {album?.Name}
                                </h3>
                                <p
                                  className="desparagraph break-text"
                                  title={album?.Description}
                                >
                                  {album?.Description}
                                </p>
                                <div className="media-meta">
                                  <img
                                    src={
                                      album?.EmployeeProfileImage ||
                                      GalleryDefaultImage
                                    }
                                    onError={handleGalleryDefaultImage}
                                    data-demo-src={album?.EmployeeProfileImage}
                                    alt=""
                                  />
                                  <a className="meta-item is-hoverable">
                                    {album?.EmployeeName}
                                  </a>
                                  <span className="separator">|</span>
                                  <span className="meta-item d-flex align-items-center">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="11"
                                      height="11"
                                      fill="currentColor"
                                      className="bi bi-calendar me-1"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                                    </svg>
                                    {moment(album?.ModifiedDate).format(
                                      "MMM DD YYYY"
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </div>
                  );
                })}
                {showGallaryDataNotFound && (
                  <div className="">
                    <div className="notfound">
                      <img
                       src="/images/no-data-found/no_gallery.png"
                        alt=""
                      />
                      <p>{noData}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" id="delete-ed">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                <p>Do you really want to delete this album?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => GalleryAlbumDelete()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}
export default GalleryBody;
